// extracted by mini-css-extract-plugin
export default {"mainNav":"MainNav_mainNav__0LxMf"};